import styled from 'styled-components';

import { Divider } from 'antd';

export const Date = styled.div`
  font-weight: normal;
`;

export const AddButton = styled.button`
   padding: 0;
   color: ${({ theme }) => theme.colors.fontTangerine};
   background-color:${({ theme }) => theme.colors.white};
   border: none;
   font-size: 14px;
   cursor: pointer;
`;

export const Placeholder = styled.div`
  color: ${({ theme }) => theme.colors.fontSilverLight};
`;

export const DividerS = styled(Divider)`
  margin: 15px 0;
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/styles.js